import React, { useEffect, useState, useRef } from 'react'
import Toaster from '../Shared/Toaster/Toaster';
import Loader from '../Shared/Loader/Loader';
import { Container, Image, Button, Modal, Form } from 'react-bootstrap';
import { ArrowLeft, Headphones, LogOut } from 'lucide-react'
import { Link } from 'react-router-dom'
import siteLogo from '../../assets/images/logo.png';
import confirmationIcon from '../../assets/images/Popup-Icons/PopupIcons_CheckWhiteIcon.svg'
import ManWorkingInOffice from '../../assets/images/Man-working-in-office.png';
import '../Shared/css/common.css';
import './DealerSignup.css';
import './NewOnBoarding.css';
import OnBoardingTabs from './OnBoardingTabs/OnBoardingTabs';
import DealerSignUpInfo from './DealerSignUpInfo/DealerSignUpInfo';
import OnBoardingVerification from './OnBoardingVerification/OnBoardingVerification';
import PrincipalInformation from './PrincipalInformation/PrincipalInformation';
import FinancialDetails from './FinancialDetails/FinancialDetails';
import DealershipInfo from './DealershipInfo/DealershipInfo';
import Attachments from './Attachments/Attachments';
import NewDigitalSignature from './DigitalSignature/DigitalSignature';
import { dealerSignup, principalInformation, financialDetails, dealershipInfoS1, dealershipInfoS2, dealershipInfoS3, newAttachments as attachments, digitalSignature } from '../../commonservices/Models/DealerSignupObjects';
import ErrorBoundary from '../Shared/ErrorBoundary';
import callAPI from '../../commonservices/APIRequests';
import { getUA } from 'react-device-detect';
import publicIp from "public-ip";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Customersupport from '../Dealer-Portal/CustomerSupport/CustomerSupport';
import { userNameCheckApi } from "../../commonservices/CommonAPICalls";
import { decrypt, encrypt, generateUsername, payloadFileFormat } from '../../commonservices/CommonMethods';
import qs from 'qs';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import Modalpopup from '../Shared/Modals/Modal';
import { useIdleTimer } from 'react-idle-timer';
import packageJson from '../../../package.json';
import { loginData, upDateMenu } from '../../store/Reducers/Shared';
import ConfirmationPopup from '../Shared/common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup';
global.appVersion = packageJson.version ? packageJson.version : '';
// import popupHeaderIcon from '../../../assets/images/Popup-Icons/PopupIcons_DollarIconWhite.svg'

const NewOnBoarding = (props) => {

    const cookies = new Cookies();
    const location = useLocation();
    const navigate = useNavigate();
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const dispatch = useDispatch();
    const textD1 = useRef();
    const textD2 = useRef();
    const textD3 = useRef();
    const textD4 = useRef();
    const textD5 = useRef();
    const textD6 = useRef();
    const storeData = useSelector((store) => store.sharedReducer)
    const [skipSignupForUserFromEmail, setSkipSignupForUserFromEmail] = useState(false);
    const [showOTPLoader, setShowOTPLoader] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpValidated, setOtpValidated] = useState(false);
    const [otpD1, setOtpD1] = useState('');
    const [otpD2, setOtpD2] = useState('');
    const [otpD3, setOtpD3] = useState('');
    const [otpD4, setOtpD4] = useState('');
    const [otpD5, setOtpD5] = useState('');
    const [otpD6, setOtpD6] = useState('');

    const [showLoginRedirectModal, setShowLoginRedirectModal] = useState(false);

    const [showCustomerSupport, setShowCustomerSupport] = useState(false);

    const [dealerSignupDetails, setDealerSignupDetails] = useState({ ...dealerSignup });
    const [principalInformationDetails, setPrincipalInformationDetails] = useState({ ...principalInformation });
    const [financialDetail, setFinancialDetail] = useState({ ...financialDetails });
    const [dealershipInfoS1Details, setDealershipInfoS1Details] = useState({ ...dealershipInfoS1 });
    const [dealershipInfoS2Details, setDealershipInfoS2Details] = useState({ ...dealershipInfoS2 });
    const [dealershipInfoS3Details, setDealershipInfoS3Details] = useState({ ...dealershipInfoS3 });
    const [attachmentsDetails, setAttachmentsDetails] = useState({ ...attachments });
    const [digitalSignatureDetails, setDigitalSignatureDetails] = useState({ ...digitalSignature });

    const [isFormDirty, setIsFormDirty] = useState(true);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const [onboardingDealerId, setOnboardingDealerId] = useState('');
    const [dealerId, setDealerId] = useState('');
    const [redirectDealerToStep, setRedirectDealerToStep] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [currSection, setCurrSection] = useState(1);
    const [innerCurrSection, setInnerCurrSection] = useState(1);
    const [sendToSlack, setSendToSlack] = useState(true);
    const [leadSourceInfo, setLeadSourceInfo] = useState('');
    const [userNameCheck, setUserNameCheck] = useState('')
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });

    const [msclkid, setMsclkid] = useState('');
    const [gclid, setGclid] = useState('');



    useEffect(() => {

        checkBuildVersion();

        // const queryParams = qs.parse(history.location.search.replace('?', ''));

        // if (queryParams.email && queryParams.leadType)
        //     getLeadData(queryParams.email, queryParams.leadType);
        // else if (props.isLender && props.leadEmail)
        //     getLeadData(props.leadEmail, 'DEALER');
        // else if (localStorage.getItem('user') && (localStorage.getItem('canCallGetData') || props.isLender))
        //     getData(true);

        // if (localStorage.getItem('user') && localStorage.getItem('onBoardingTab') && +localStorage.getItem('onBoardingTab') > 2)
        if (localStorage.getItem('user'))
            getData(true);

        //Both wont come at the same time. Preference will be Cookies first, then Query Params
        if (cookies.get('_gcl_aw')) {
            setGclid(cookies.get('_gcl_aw').substring(cookies.get('_gcl_aw').lastIndexOf('.') + 1));
        }
        else if (cookies.get('_uetmsclkid')) {
            setMsclkid(cookies.get('_uetmsclkid').substring(4));
        }
        // else if (queryParams.gclid) {
        //     setGclid(queryParams.gclid);
        // }
        // else if (queryParams.msclkid) {
        //     setMsclkid(queryParams.msclkid);
        // }

        if (cookies.get('lead_src_details')) {
            setLeadSourceInfo(cookies.get('lead_src_details', { doNotParse: false }));
        }

    }, []);

    useEffect(() => {

        if (currSection === 3)
            getData();

        if (currSection === 4 && !partnerDetails.enablePlaid) {
            setCurrSection(currSection + 1)
        }

    }, [currSection]);




    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };

    const userNameChecking = async (data) => {
        let result = await userNameCheckApi(data)
        if (result?.warningReason) {
            setUserNameCheck(result.warningReason)
            setDealerSignupDetails({
                ...dealerSignupDetails,
                username: result.alternateUsername
            })
        } else {
            setUserNameCheck('')
        }

        if (result?.message) {
            setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: result.message,
                showToaster: true
            });
        }
    }

    useEffect(() => {
        let generatedUserName = ''
        if(dealerSignupDetails.firstName && dealerSignupDetails.lastName){
            generatedUserName = generateUsername(dealerSignupDetails.firstName, dealerSignupDetails.lastName)

        
            setDealerSignupDetails({
                ...dealerSignupDetails,
                username: generatedUserName
            })
        }
    }, [dealerSignupDetails.firstName, dealerSignupDetails.lastName])

    const twoWayBind = (key, value, innerStep = null) => {

        setIsFormDirty(true);

        if (key.toLowerCase().indexOf('email') > -1)
            value = value.toLowerCase();
       
        if(key.toLowerCase() === 'username')
            value = value.toLowerCase();

        const numberFields = [
            //"zipCode",
            // "homeZipCode",
            // "dealerZipCode",
            "numberOfLocations",
            "avgUnitsSoldPerMonth",
            "avgInventoryAge",
            //"avgSalePrice",
            "yearsInBusiness"
        ];

        if (numberFields.includes(key))
            value = value.replace(/[^0-9]/g, '');


        switch (currSection) {

            case 1:

                if (!sendToSlack && ['firstName', 'lastName', 'dealerName', 'email'].includes(key)) {
                    setSendToSlack(true);
                }

                setDealerSignupDetails({
                    ...dealerSignupDetails,
                    [key]: value
                })

                break;

            case 2:
                break;
            case 3:
                setPrincipalInformationDetails({
                    ...principalInformationDetails,
                    [key]: value
                })
                break;
            case 4:
                break;
            case 5:

                if (innerStep === 1) {

                    setDealershipInfoS1Details({
                        ...dealershipInfoS1Details,
                        [key]: value
                    })

                     let tempData = {...dealershipInfoS1Details}
                     let referalKeys = tempData?.referralInformation?.map(item=>item?.objectKey)
                    if(referalKeys.includes(key)){
                        let index = tempData?.referralInformation?.findIndex(item => item.objectKey === key)
                        if(index > -1){
                            tempData.referralInformation[index].value = value 
                            setDealershipInfoS1Details(tempData)
                        }
                    } 
                }
                else if (innerStep === 2) {

                    setDealershipInfoS2Details({
                        ...dealershipInfoS2Details,
                        [key]: value
                    })

                }
                else if (innerStep === 3) {

                    setDealershipInfoS3Details({
                        ...dealershipInfoS3Details,
                        [key]: value
                    })

                }

                break;
            case 6:
                setAttachmentsDetails({
                    ...attachmentsDetails,
                    [key]: value
                })
                break;
            case 7:
                setDigitalSignatureDetails({
                    ...digitalSignatureDetails,
                    [key]: value
                })
                break;
            default:
                break;

        }

    }

    const resetLeaseData = () => {

        setDealershipInfoS2Details({
            ...dealershipInfoS2Details,
            leasingCompany: '',
            leaseContactPhoneNumber: '',
            leaseEndDate: '',
            leaseContactName: ''
        })

    }

    const submit = async (event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true, isSubmitted = false) => {

        event.preventDefault();
        event.stopPropagation();

        if (isPreviousClick) {
            if (currSection === 5 && !partnerDetails.enablePlaid) {
                setCurrSection(currSection - 2);
                return;
            }
            if (currSection === 6)
                setInnerCurrSection(3);
            setCurrSection(currSection - 1);
            return;
        }
        else {

            if (isFormDirty || isSubmitted) {

                setShowLoader(true);

                let apiurl = '/auth/api/v1/dealer/saveDealerOnboardingInfo', req = {};
                //let apiurl = 'http://localhost:5000/api/v1/dealer/saveDealerOnboardingInfo', req = {};

                switch (currSection) {

                    case 1:
                        req = { ...dealerSignupDetails };
                        req.ssn = encrypt(req.ssn);
                        req.dealerDOB = moment(req.dealerDOB).format('MM-DD-YYYY');

                        const locationDetails = location.search.split('?');
                        const queryParams = qs.parse(location.search.replace('?', ''));

                        req.referral = locationDetails && locationDetails.length > 1 && (queryParams && Object.keys(queryParams).length > 0 && Object.keys(queryParams).filter(item => !['msclkid', 'gclid', 'oauth_state_id'].includes(item)).length > 0) ? locationDetails[1] : '';
                        let ipAddress = await publicIp.v4();

                        req.ipAddress = ipAddress;
                        req.macAddres = '';
                        req.deviceName = getUA;

                        if (msclkid)
                            req.msclkId = msclkid;

                        if (gclid)
                            req.gclId = gclid;

                        if (leadSourceInfo)
                            req.leadSourceInfo = leadSourceInfo

                        apiurl = '/auth/api/v1/auth/registerDealer';
                        // apiurl = 'http://localhost:5000/api/v1/auth/registerDealer';

                        break;
                    case 2:
                        setCurrSection(currSection + 1);
                        setShowLoader(false);
                        localStorage.setItem('onBoardingTab', 2);
                        localStorage.setItem('canCallGetData', true);
                        break;
                    case 3:
                        req = { ...principalInformationDetails };
                        req.dealerPrincipal = req.dealerPrincipal.map(item => { return { ...item } });
                        if (req?.dealerPrincipal?.length > 0) {
                            req.dealerPrincipal[0].homeAddressLine1 = dealerSignupDetails?.homeAddressLine1 ?? ''
                            req.dealerPrincipal[0].city = dealerSignupDetails?.homeCity ?? ''
                            req.dealerPrincipal[0].state = dealerSignupDetails?.homeState ?? ''
                            req.dealerPrincipal[0].zipCode = dealerSignupDetails?.homeZipCode ?? ''
                        }

                        if (req.dealerPrincipal && req.dealerPrincipal.length > 0) {

                            req.dealerPrincipal.forEach(item => {
                                item.ssn = encrypt(item.ssn);
                            });

                            const sumOfOwnership = req.dealerPrincipal.reduce((total, item) => {
                                return total + Number(item.ownership)
                            }, 0);

                            if (sumOfOwnership > 100) {
                                setToaster({
                                    header: 'Error',
                                    class: 'error-toaster',
                                    content: "Ownership can't exceed 100%.",
                                    showToaster: true
                                });
                                setShowLoader(false);
                                return;
                            }
                        }
                        break;
                    case 4:
                        req = { ...financialDetail };
                        break;
                    case 5:

                        if (innerStep === 1) {

                            req = { ...dealershipInfoS1Details };
                            if(dealershipInfoS1Details?.referralInformation?.length){
                                req.referralInformation = {};
                                dealershipInfoS1Details?.referralInformation.forEach(item=>{
                                    req.referralInformation[`${item.label}`] = item.value;
                                });
                            }
                        }
                        else if (innerStep === 2) {

                            req = { ...dealershipInfoS2Details };
                            if (req.leaseEndDate)
                                req.leaseEndDate = moment(req.leaseEndDate).format("MM-DD-yyyy")

                        }
                        else if (innerStep === 3) {

                            req = { ...dealershipInfoS3Details };

                        }

                        break;
                    case 6:
                        req = {
                            _id: attachmentsDetails._id,
                            selectedTab: 6
                        };
                        break;
                    case 7:
                        req = { ...digitalSignatureDetails };
                        break;
                    default:
                        break;

                }

                if (currSection > 2) {

                    if (onboardingDealerId)
                        req._id = onboardingDealerId;

                }
                else {

                    if (dealerId)
                        req._id = dealerId;

                }

                if (sessionStorage.getItem('tempDealerId'))
                    req.dealer_id = sessionStorage.getItem('tempDealerId');

                if (isSubmitted)
                    req.onBoardFormSubmitted = true;

                return callAPI.post(apiurl, req)
                    .then((response) => {

                        if (response.status === 200) {

                            if (apiurl.indexOf('registerDealer') !== -1) {
                                let date = new Date();
                                const pastDay = new Date(date.setDate(date.getDate() - 100));
                                cookies.remove('lead_src_details', '/', pastDay, 0, 'leverauto.com', true);
                            }

                            if (currSection === 1) {
                                // if (sendToSlack && innerCurrSection === 1)
                                //     sendSlackNotification();
                                sendToLeadBadge();
                                sendToSpotio();
                            }

                            setIsFormDirty(false);
                            const onBoardingTab = localStorage.getItem("OnBoardingTab");

                            if (currSection === 1) {
                                setDealerId(response.data._id);
                            }

                            if (currSection > 2 && !onboardingDealerId && response.data._id)
                                setOnboardingDealerId(response.data._id)
                            else if (currSection > 2 && !dealerId && response.data.userId)
                                setDealerId(response.data.userId);

                            if (currSection === 1 && (response.data.message && response.data.message.toLowerCase().indexOf('email') > -1)) {

                                switch (response.data.userCompletedStage.toLowerCase()) {

                                    case 'personal details':

                                        if (response.data.signUpOTPVerified) {
                                            setInnerCurrSection(redirectDealerToStep);
                                        }
                                        else {
                                            setShowOtpModal(true);
                                            setRedirectDealerToStep(2);
                                        }
                                        break;
                                    case 'address details':
                                        if (response.data.signUpOTPVerified) {
                                            setCurrSection(3);
                                            localStorage.setItem('OnBoardingTab', 2);
                                        }
                                        else {
                                            setShowOtpModal(true);
                                            setRedirectDealerToStep(3);
                                        }
                                        break;
                                    case 'sign up':
                                        setShowLoginRedirectModal(true);
                                        break;
                                    default:
                                        break;

                                }

                            }

                            if (currSection === 7 && isSubmitted) {

                                if (props.isLender) {
                                    setToaster({
                                        header: 'Success',
                                        class: 'success-toaster',
                                        content: "Dealer application submitted successfully.",
                                        showToaster: true
                                    });
                                }
                                setIsFormSubmitted(true);
                                localStorage.setItem('OnBoardingTab', 7);
                                localStorage.setItem('onBoardFormSubmitted', true);
                                sendToSpotio();
                                getData();

                            }
                            else if (currSection === 7) {
                                localStorage.setItem('OnBoardingTab', 7);
                                getData();
                            }

                            if (forwardGlobalStep) {

                                if (currSection === 1 && response.data.user) {

                                    localStorage.setItem('token', response.data.token);
                                    localStorage.setItem('user', JSON.stringify(response.data.user));
                                    //localStorage.setItem('OnBoardingTab', 2);
                                    localStorage.setItem('onBoardFormSubmitted', response.data.onBoardFormSubmitted);
                                    dispatch(loginData(response.data.user));
                                    dispatch(upDateMenu(response.data.dynamicMenu && response.data.dynamicMenu.length > 0 ? response.data.dynamicMenu[0].menu : []));
                                    setDealerId(response.data.user ? response.data.user._id : '');
                                    setCurrSection(3);
                                    setInnerCurrSection(1);
                                    localStorage.setItem('canCallGetData', true);
                                    if (!onBoardingTab || onBoardingTab === 'undefined' || (onBoardingTab && onBoardingTab < currSection))
                                        localStorage.setItem("OnBoardingTab", 2);

                                }
                                else if (currSection === 1 && skipSignupForUserFromEmail) {
                                    setCurrSection(3);
                                    setInnerCurrSection(1);
                                    localStorage.setItem('canCallGetData', true);
                                    if (!onBoardingTab || onBoardingTab === 'undefined' || (onBoardingTab && onBoardingTab < currSection))
                                        localStorage.setItem("OnBoardingTab", 2);
                                }
                                else {
                                    setCurrSection(currSection + 1);
                                    setInnerCurrSection(1);
                                    if (currSection + 1 === 3)
                                        localStorage.setItem('canCallGetData', true);
                                    if (!onBoardingTab || onBoardingTab === 'undefined' || (onBoardingTab && onBoardingTab < currSection))
                                        localStorage.setItem("OnBoardingTab", currSection);
                                }

                            }

                            setShowLoader(false);
                            return true;

                        }
                        else {
                            setShowLoader(false);
                            setToaster({
                                header: 'Error',
                                class: 'error-toaster',
                                content: response.message,
                                showToaster: true
                            });

                            return false;

                        }

                    })

            }
            else {

                const onBoardingTab = localStorage.getItem("OnBoardingTab");

                if (forwardGlobalStep) {

                    if (currSection === 2)
                        localStorage.setItem('canCallGetData', true);

                    setCurrSection(currSection + 1);
                    if (onBoardingTab && onBoardingTab < currSection)
                        localStorage.setItem("OnBoardingTab", currSection);
                    else if (!onBoardingTab)
                        localStorage.setItem("OnBoardingTab", currSection);
                }

                return true;

            }

        }

    }

    const getLeadData = async (email, leadType, setLoader = true) => {

        let ipAddress = await publicIp.v4();

        const req = {
            email: email,
            ipAddress: ipAddress,
            macAddres: ''
        }

        if (sessionStorage.getItem('tempDealerId'))
            req.dealer_id = sessionStorage.getItem('tempDealerId');

        return callAPI.post('/auth/api/v1/auth/getDealerRegistration', req)
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.dealer && response.data.dealer._id)
                        setDealerId(response.data.dealer._id);

                    setDealerSignupDetails({
                        ...dealerSignupDetails,
                        firstName: response.data.dealer && response.data.dealer.firstName ? response.data.dealer.firstName : '',
                        lastName: response.data.dealer && response.data.dealer.lastName ? response.data.dealer.lastName : '',
                        dealerName: response.data.dealer && response.data.dealer.dealerName ? response.data.dealer.dealerName : '',
                        email: response.data.dealer && response.data.dealer.email ? response.data.dealer.email : '',
                        phone: response.data.dealer && response.data.dealer.phone ? response.data.dealer.phone : '',
                        dateofBirth: response.data.dateofBirth && response.data.dealer.dateofBirth ? response.data.dealer.dateofBirth : '',
                        dealerAddressLine1: response.data.dealer && response.data.dealer.address && response.data.dealer.address.addressLine1 ? response.data.dealer.address.addressLine1 : '',
                        dealerAddressLine2: response.data.dealer && response.data.dealer.address && response.data.dealer.address.addressLine2 ? response.data.dealer.address.addressLine2 : '',
                        dealerCity: response.data.dealer && response.data.dealer.address && response.data.dealer.address.city ? response.data.dealer.address.city : '',
                        dealerState: response.data.dealer && response.data.dealer.address && response.data.dealer.address.state ? response.data.dealer.address.state : '',
                        dealerZipCode: response.data.dealer && response.data.dealer.address && response.data.dealer.address.zipCode ? response.data.dealer.address.zipCode : '',
                        ssn: response.data.dealer && response.data.dealer.ssn && response.data.dealer.ssn.length > 11 ? decrypt(response.data.dealer.ssn) : (response.data.dealer.ssn ? response.data.dealer.ssn : ''),
                        requestedFacilityAmount: response.data.dealer && response.data.dealer.requestedFacilityAmount ? response.data.dealer.requestedFacilityAmount : '',
                        homeAddressLine1: response.data.dealer && response.data.dealer.dealerHomeAddress && response.data.dealer.dealerHomeAddress.addressLine1 ? response.data.dealer.dealerHomeAddress.addressLine1 : '',
                        homeAddressLine2: response.data.dealer && response.data.dealer.dealerHomeAddress && response.data.dealer.dealerHomeAddress.addressLine2 ? response.data.dealer.dealerHomeAddress.addressLine2 : '',
                        homeCity: response.data.dealer && response.data.dealer.dealerHomeAddress && response.data.dealer.dealerHomeAddress.city ? response.data.dealer.dealerHomeAddress.city : '',
                        homeState: response.data.dealer && response.data.dealer.dealerHomeAddress && response.data.dealer.dealerHomeAddress.state ? response.data.dealer.dealerHomeAddress.state : '',
                        homeZipCode: response.data.dealer && response.data.dealer.dealerHomeAddress && response.data.dealer.dealerHomeAddress.zipCode ? response.data.dealer.dealerHomeAddress.zipCode : '',
                    });

                    if (leadType === 'DEALER') {
                        setInnerCurrSection(2);
                    }

                    if (!props.isLender) {

                        if (response.data.dealer && response.data.dealer.signUpOTPVerified) {
                            localStorage.setItem('token', response.data.token);
                            localStorage.setItem('user', JSON.stringify(response.data.dealer));
                            localStorage.setItem('onBoardFormSubmitted', false);
                            setDealerId(response.data.dealer ? response.data.dealer._id : '');
                            dispatch(loginData(response.data.dealer));
                            dispatch(upDateMenu(response.data.dynamicMenu && response.data.dynamicMenu.length > 0 ? response.data.dynamicMenu[0].menu : []));
                            setSkipSignupForUserFromEmail(true);
                        }

                    }
                    else {
                        setDealerId(response.data.dealer ? response.data.dealer._id : '');
                        setSkipSignupForUserFromEmail(true);
                    }

                    if (setLoader)
                        setShowLoader(false);

                    if (!props.isLender)
                        navigate('/DealerSignup', { replace: true })

                }
                else {
                    if (setLoader)
                        setShowLoader(false);

                    if (!props.isLender)
                        navigate('/DealerSignup', { replace: true })

                }

            })

    }

    const getData = (processSectionChange = false, setLoader = true) => {

        if (setLoader)
            setShowLoader(true);

        const req = sessionStorage.getItem('tempDealerId') ? {
            dealer_id: sessionStorage.getItem('tempDealerId')
        } : null

        return callAPI.get('/auth/api/v1/dealer/getDealerOnboardingInfo', req)
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.dealerInfo && response.data.dealerInfo._id)
                        setOnboardingDealerId(response.data.dealerInfo._id);

                    if (response.data.dealerInfo && response.data.dealerInfo.dealerId)
                        setDealerId(response.data.dealerInfo.dealerId);

                    if (processSectionChange) {

                        if (localStorage.getItem('onBoardFormSubmitted') && localStorage.getItem('onBoardFormSubmitted') == 'true') {

                            localStorage.setItem('OnBoardingTab', 7);
                            setCurrSection(7);
                            setIsFormSubmitted(true);

                        }
                        else {

                            localStorage.setItem('OnBoardingTab', response.data.dealerInfo.selectedTab);
                            let tab = +localStorage.getItem('OnBoardingTab');

                            switch (tab) {

                                case 0:
                                    localStorage.setItem('OnBoardingTab', 2);
                                    setCurrSection(3);
                                    break;
                                case 1:
                                    localStorage.setItem('OnBoardingTab', 3);
                                    setCurrSection(4);
                                    break;
                                case 2:
                                    localStorage.setItem('OnBoardingTab', 4);
                                    setCurrSection(5);
                                    break;
                                case 3:
                                    localStorage.setItem('OnBoardingTab', 4);
                                    setCurrSection(5);
                                    setInnerCurrSection(2);
                                    break;
                                case 4:
                                    localStorage.setItem('OnBoardingTab', 4);
                                    setCurrSection(5);
                                    setInnerCurrSection(3);
                                    break;
                                case 5:
                                    localStorage.setItem('OnBoardingTab', 5);
                                    setCurrSection(6);
                                    break;
                                case 6:
                                    localStorage.setItem('OnBoardingTab', 6);
                                    setCurrSection(7);
                                    break;
                                case 7:
                                    localStorage.setItem('OnBoardingTab', 7);
                                    setCurrSection(7);
                                    break;
                                default:
                                    localStorage.setItem('OnBoardingTab', 2);
                                    setCurrSection(3);
                                    break;

                            }

                            if (window.location.href.toLowerCase().indexOf('oauth') > -1)
                                setCurrSection(4);

                        }

                    }

                    setDealerSignupDetails({
                        ...dealerSignupDetails,
                        firstName: response.data.dealerInfo.personalDetails.firstName ? response.data.dealerInfo.personalDetails.firstName : '',
                        lastName: response.data.dealerInfo.personalDetails.lastName ? response.data.dealerInfo.personalDetails.lastName : '',
                        dealerName: response.data.dealerInfo.personalDetails.dealerName ? response.data.dealerInfo.personalDetails.dealerName : '',
                        email: response.data.dealerInfo.personalDetails.email ? response.data.dealerInfo.personalDetails.email : '',
                        phone: response.data.dealerInfo.personalDetails.phone ? response.data.dealerInfo.personalDetails.phone : '',
                        dealerDOB: response.data.dealerInfo.personalDetails.dealerDOB ? response.data.dealerInfo.personalDetails.dealerDOB : '',
                        dealerAddressLine1: response.data.dealerInfo.personalDetails.addressLine1 ? response.data.dealerInfo.personalDetails.addressLine1 : '',
                        dealerAddressLine2: response.data.dealerInfo.personalDetails.addressLine2 ? response.data.dealerInfo.personalDetails.addressLine2 : '',
                        dealerCity: response.data.dealerInfo.personalDetails.city ? response.data.dealerInfo.personalDetails.city : '',
                        dealerState: response.data.dealerInfo.personalDetails.state ? response.data.dealerInfo.personalDetails.state : '',
                        dealerZipCode: response.data.dealerInfo.personalDetails.zipCode ? response.data.dealerInfo.personalDetails.zipCode : '',
                        ssn: response.data.dealerInfo.personalDetails.ssn && response.data.dealerInfo.personalDetails.ssn.length > 11 ? decrypt(response.data.dealerInfo.personalDetails.ssn) : (response.data.dealerInfo.personalDetails.ssn ? response.data.dealerInfo.personalDetails.ssn : ''),
                        requestedFacilityAmount: response.data.dealerInfo.personalDetails.requestedFacilityAmount ? response.data.dealerInfo.personalDetails.requestedFacilityAmount : '',
                        homeAddressLine1: response.data.dealerInfo.personalDetails.homeAddressLine1 ? response.data.dealerInfo.personalDetails.homeAddressLine1 : '',
                        homeAddressLine2: response.data.dealerInfo.personalDetails.homeAddressLine2 ? response.data.dealerInfo.personalDetails.homeAddressLine2 : '',
                        homeCity: response.data.dealerInfo.personalDetails.homeCity ? response.data.dealerInfo.personalDetails.homeCity : '',
                        homeState: response.data.dealerInfo.personalDetails.homeState ? response.data.dealerInfo.personalDetails.homeState : '',
                        homeZipCode: response.data.dealerInfo.personalDetails.homeZipCode ? response.data.dealerInfo.personalDetails.homeZipCode : '',
                        validationMessage: response?.data?.dealerInfo?.personalDetails?.validationMessage ?? ''
                    });

                    setPrincipalInformationDetails({
                        ...principalInformation,
                        dealerPrincipal: response.data.dealerInfo.dealerPrincipal ?
                            response.data.dealerInfo.dealerPrincipal.map(item => {
                                item.ssn = item.ssn && item.ssn.length > 11 ? decrypt(item.ssn) : item.ssn;
                                return item;
                            }) : [],
                    })

                    setDealershipInfoS1Details({
                        ...dealershipInfoS1Details,
                        numberOfLocations: response.data.dealerInfo.numberOfLocations ? response.data.dealerInfo.numberOfLocations : '',
                        avgUnitsSoldPerMonth: response.data.dealerInfo.avgUnitsSoldPerMonth ? response.data.dealerInfo.avgUnitsSoldPerMonth : '',
                        avgInventoryAge: response.data.dealerInfo.avgInventoryAge ? response.data.dealerInfo.avgInventoryAge : '',
                        avgSalePrice: response.data.dealerInfo.avgSalePrice ? response.data.dealerInfo.avgSalePrice : '',
                        yearsInBusiness: response.data.dealerInfo.yearsInBusiness ? response.data.dealerInfo.yearsInBusiness : '',
                        webAddress: response.data.dealerInfo.webAddress ? response.data.dealerInfo.webAddress : '',
                        auctionAccessNumber: response.data.dealerInfo.auctionAccessNumber ? response.data.dealerInfo.auctionAccessNumber : '',
                        referralInformation: response.data.dealerInfo?.personalDetails?.referralInformation ? response.data.dealerInfo?.personalDetails?.referralInformation : []
                    })

                    setDealershipInfoS2Details({
                        ...dealershipInfoS2Details,
                        buildingOwned: response.data.dealerInfo.buildingOwned ? response.data.dealerInfo.buildingOwned : false,
                        leasingCompany: response.data.dealerInfo.leasingCompany ? response.data.dealerInfo.leasingCompany : '',
                        leaseContactName: response.data.dealerInfo.leaseContactName ? response.data.dealerInfo.leaseContactName : '',
                        leaseContactPhoneNumber: response.data.dealerInfo.leaseContactPhoneNumber ? response.data.dealerInfo.leaseContactPhoneNumber : '',
                        leaseEndDate: response.data.dealerInfo.leaseEndDate ? new Date(response.data.dealerInfo.leaseEndDate) : '',
                    })

                    setDealershipInfoS3Details({
                        ...dealershipInfoS3Details,
                        commercialInsuranceName: response.data.dealerInfo.commercialInsuranceName ? response.data.dealerInfo.commercialInsuranceName : '',
                        commercialInsuranceEmail: response.data.dealerInfo.commercialInsuranceEmail ? response.data.dealerInfo.commercialInsuranceEmail : '',
                        commercialInsurancePhone: response.data.dealerInfo.commercialInsurancePhone ? response.data.dealerInfo.commercialInsurancePhone : '',
                        currentFloorPlanCompaniesUsed: response.data.dealerInfo.currentFloorPlanCompaniesUsed ? [...response.data.dealerInfo.currentFloorPlanCompaniesUsed] : [],
                        currentRetailFinanceUsed: response.data.dealerInfo.currentRetailFinanceUsed ? [...response.data.dealerInfo.currentRetailFinanceUsed] : [],
                        productCompaniesUsed: response.data.dealerInfo.productCompaniesUsed ? [...response.data.dealerInfo.productCompaniesUsed] : [],
                    })

                    const tempDocsObj = JSON.parse(JSON.stringify(attachments));

                    Object.keys(tempDocsObj).forEach(item => {

                        if (item === '_id' || item === 'selectedTab')
                            return;

                        const obj = response.data.documents && response.data.documents.length > 0 ? response.data.documents.filter(item1 => item1.documentType === item) : null;

                        if (obj && obj.length > 0) {

                            tempDocsObj[item].docs = [
                                ...obj.map(item1 => {

                                    return {
                                        _id: item1._id,
                                        fileName: item1.fileName ? item1.fileName : '',
                                        base64Image: item1.url ? item1.url : '',
                                        fileType: item1.fileType ? payloadFileFormat(item1.fileName, item1.fileType) : '',
                                    }

                                })
                            ];

                        }
                        else {

                            tempDocsObj[item].docs = [];

                        }
                    });
                    setAttachmentsDetails({ ...tempDocsObj });

                    const digitalSignatureIndex = response.data.documents && response.data.documents.length > 0 && response.data.documents.findIndex(item => item.documentType === 'digitalSignature') > -1 ? response.data.documents.findIndex(item => item.documentType === 'digitalSignature') : -1
                    const onBoardingPdfIndex = response.data.documents && response.data.documents.length > 0 && response.data.documents.findIndex(item => item.documentType === 'onBoardingPdf') > -1 ? response.data.documents.findIndex(item => item.documentType === 'onBoardingPdf') : -1

                    setDigitalSignatureDetails({
                        ...digitalSignatureDetails,
                        name: response.data.dealerInfo.name,
                        title: response.data.dealerInfo.title,
                        onBoardFormSubmitted: localStorage.getItem('onBoardFormSubmitted') && localStorage.getItem('onBoardFormSubmitted') == 'true' ? true : false,
                        digitalSignature: digitalSignatureIndex > -1 ?
                            {
                                _id: response.data.documents[digitalSignatureIndex]._id ? response.data.documents[digitalSignatureIndex]._id : '',
                                fileName: response.data.documents[digitalSignatureIndex].fileName ? response.data.documents[digitalSignatureIndex].fileName : '',
                                base64Image: response.data.documents[digitalSignatureIndex].url ? response.data.documents[digitalSignatureIndex].url : '',
                                fileType: response.data.documents[digitalSignatureIndex].fileType ? response.data.documents[digitalSignatureIndex].fileType : ''
                            } :
                            {
                                fileName: '',
                                base64Image: '',
                                fileType: ''
                            },
                        onBoardingPdf: onBoardingPdfIndex > -1 ?
                            {
                                _id: response.data.documents[onBoardingPdfIndex]._id ? response.data.documents[onBoardingPdfIndex]._id : '',
                                fileName: response.data.documents[onBoardingPdfIndex].fileName ? response.data.documents[onBoardingPdfIndex].fileName : '',
                                base64Image: response.data.documents[onBoardingPdfIndex].url ? response.data.documents[onBoardingPdfIndex].url : '',
                                fileType: response.data.documents[onBoardingPdfIndex].fileType ? response.data.documents[onBoardingPdfIndex].fileType : ''
                            } :
                            {
                                fileName: '',
                                base64Image: '',
                                fileType: ''
                            },
                    })

                    if (setLoader)
                        setShowLoader(false);

                }
                else {
                    if (setLoader)
                        setShowLoader(false);

                }

            })

    }

    const sendOTP = (event) => {

        event.preventDefault();
        event.stopPropagation();

        setShowLoader(true);

        return callAPI.post('/auth/api/v1/message/sendmessage', { _id: dealerId })
            .then((response) => {

                if (response.status === 200) {

                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: "OTP sent successfully.",
                        showToaster: true
                    });
                    setShowLoader(false);
                    return true;

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });
                    setShowLoader(false);
                    return false;

                }

            })

    }
    const sendOTPEmail = (event) => {

        event.preventDefault();
        event.stopPropagation();

        setShowLoader(true);

        return callAPI.post('/auth/api/v1/auth/sendOTPtoEmail', { _id: dealerId })
            .then((response) => {

                if (response.status === 200) {

                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: "OTP sent to email successfully.",
                        showToaster: true
                    });
                    setShowLoader(false);
                    return true;

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });
                    setShowLoader(false);
                    return false;

                }

            })

    }

    const verifyOTP = async (event, otp) => {

        event.preventDefault();
        event.stopPropagation();

        setShowLoader(true);

        let ipAddress = await publicIp.v4();

        const req = {
            userId: dealerId,
            ipAddress: ipAddress ? ipAddress : '',
            otpNumber: otp,
            trustedDevice: true,
            deviceName: getUA
        }

        if (currSection === 1) {
            req.isFromStep1 = true;
        }
        // return callAPI.post('/auth/api/v1/auth/verifyOnboardingOTP', req)

        return callAPI.post('/auth/api/v1/auth/verifyOnboardingOTP', req)
            .then((response) => {

                if (response.status === 200) {

                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: "OTP verified successfully.",
                        showToaster: true
                    });

                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    //localStorage.setItem('OnBoardingTab', 2);
                    localStorage.setItem('onBoardFormSubmitted', response.data.onBoardFormSubmitted);
                    dispatch(loginData(response.data.user));
                    // dispatch(upDateMenu(response.data.dynamicMenu && response.data.dynamicMenu.length > 0 ? response.data.dynamicMenu[0].menu : []));

                    const cookieDateExpiresIn = new Date();
                    cookieDateExpiresIn.setDate(cookieDateExpiresIn.getDate() + 90);

                    cookies.set('isTrustedDevice', true, { expires: cookieDateExpiresIn });

                    if (redirectDealerToStep) {

                        setShowOtpModal(false);
                        // if (redirectDealerToStep && redirectDealerToStep === 2) {
                        //     setInnerCurrSection(redirectDealerToStep);
                        //     setRedirectDealerToStep('');
                        // }
                        // else if (redirectDealerToStep && redirectDealerToStep === 3) {
                        //     setCurrSection(redirectDealerToStep);
                        //     localStorage.setItem('OnBoardingTab', 2);
                        //     setRedirectDealerToStep('');
                        // }
                        setCurrSection(3);
                        localStorage.setItem('OnBoardingTab', 2);
                        setRedirectDealerToStep('');

                    }
                    else {
                        localStorage.setItem('OnBoardingTab', 2);
                    }

                    setShowLoader(false);
                    return true;

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });
                    setShowLoader(false);
                    return false;

                }

            })

    }

    const getTrainingVideo = async () => {

        return callAPI.get('/lender/api/v1/shared/getVideo', { documentType: 'ONBOARDING_VIDEO' })
            .then((response) => {

                if (response.status === 200) {

                    return response.data.url;

                }
                else {
                    return "";

                }

            })

    }

    const changeTabForLender = (tab) => {

        if (sessionStorage.getItem('tempDealerId')) {
            setCurrSection(tab);
            setInnerCurrSection(1);
        }

    }

    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        //timeout: idleTime, default timeout 20min according to npm documentation
        onIdle: () => { /* Empty function */ },
        debounce: 500,
        onAction: () => extendSession(),
        eventsThrottle: 60000
    })

    const extendSession = () => {

        if (!props.isLender && storeData.token) {

            return callAPI.post('/auth/api/v1/auth/keepActive', {})
                .then((response) => {

                    if (response.status === 200) {



                    }
                    else {

                        console.log(response.message);

                    }

                })

        }

    }

    const versionCheckforReload = (versionA, versionB) => {
        const versionsA = versionA.split(/\./g);
        const versionsB = versionB.split(/\./g);
        while (versionsA.length || versionsB.length) {
            const a = Number(versionsA.shift());

            const b = Number(versionsB.shift());
            if (a === b) continue;
            return a > b || isNaN(b);
        }
        return false;
    };

    const checkBuildVersion = () => {

        callAPI.get(window.location.origin + '/meta.json?_=' + new Date().getTime())
            .then((jsonDetails) => {
                const localVersion = global.appVersion;
                if (jsonDetails.status === 200) {

                    const metaDataversion = jsonDetails.data && jsonDetails.data.version ? jsonDetails.data.version : '';
                    const fullyLoaded = JSON.parse(localStorage.getItem('isReloaded'));
                    console.log("localversion", localVersion);
                    console.log("metaDataversion", metaDataversion)
                    const isReload = versionCheckforReload(metaDataversion, localVersion);
                    if (isReload && !fullyLoaded) {
                        localStorage.setItem('isReloaded', true);
                        window.location.reload();
                    }

                }

                else {


                }

            });

    }

    const setOtpDigits = (currentDigit, value) => {

        if (value && '0123456789'.indexOf(value) === -1) {
            return;
        }

        switch (currentDigit) {

            case 1:
                setOtpD1(value);
                if (value)
                    textD2.current.focus();
                // else
                //     textD1.current.focus();
                break;
            case 2:
                setOtpD2(value);
                if (value)
                    textD3.current.focus();
                // else
                //     textD1.current.focus();
                break;
            case 3:
                setOtpD3(value);
                if (value)
                    textD4.current.focus();
                // else
                //     textD2.current.focus();
                break;
            case 4:
                setOtpD4(value);
                if (value)
                    textD5.current.focus();
                // else
                //     textD3.current.focus();
                break;
            case 5:
                setOtpD5(value);
                if (value)
                    textD6.current.focus();
                // else
                //     textD4.current.focus();
                break;
            case 6:
                setOtpD6(value);
                if (value)
                    textD6.current.focus();
                // else
                //     textD5.current.focus();
                break;
            default:
                break;

        }

    }

    const keyDownHandler = (currentDigit, value, keyCode) => {

        if (keyCode === 8) {

            switch (currentDigit) {

                case 1:
                    textD1.current.focus();
                    break;
                case 2:
                    if (value) {
                        setOtpD2('');
                    }
                    else {
                        setOtpD1('');
                        textD1.current.focus();
                    }
                    break;
                case 3:
                    if (value) {
                        setOtpD3('');
                    }
                    else {
                        setOtpD2('');
                        textD2.current.focus();
                    }
                    break;
                case 4:
                    if (value) {
                        setOtpD4('');
                    }
                    else {
                        setOtpD3('');
                        textD3.current.focus();
                    }
                    break;
                case 5:
                    if (value) {
                        setOtpD5('');
                    }
                    else {
                        setOtpD4('');
                        textD4.current.focus();
                    }
                    break;
                case 6:
                    if (value) {
                        setOtpD6('');
                    }
                    else {
                        setOtpD5('');
                        textD5.current.focus();
                    }
                    break;
                default:
                    break;

            }

        }

    }

    const verifyOTPInPopup = async (event) => {

        event.preventDefault();
        event.stopPropagation();
        setOtpValidated(true);

        const form = event.currentTarget;

        if (form.checkValidity() !== false) {

            setShowOTPLoader(true);

            const otp = otpD1 + otpD2 + otpD3 + otpD4 + otpD5 + otpD6;

            let success = await verifyOTP(event, otp);

            if (success) {
                setOtpValidated(false);
                setShowOTPLoader(false);
            }
            else
                setShowOTPLoader(false);

        }

    }

    const sendSlackNotification = () => {

        if (process.env.REACT_APP_ENVIRONMENT === 'production') {

            const req = {
                name: dealerSignupDetails.firstName + ' ' + dealerSignupDetails.lastName,
                businessName: dealerSignupDetails.dealerName,
                emailAddress: dealerSignupDetails.email,
                phoneNumber: dealerSignupDetails.phone
            }

            return callAPI.post('/workflow/api/v1/shared/slackNotifications', req)
                .then((response) => {

                    if (response.status === 200) {
                        setSendToSlack(false);
                    }

                })

        }

    }

    const sendToLeadBadge = () => {

        if (process.env.REACT_APP_ENVIRONMENT === 'production') {

            const req = {
                firstName: dealerSignupDetails.firstName,
                lastName: dealerSignupDetails.lastName,
                companyName: dealerSignupDetails.dealerName,
                email: dealerSignupDetails.email,
                phone: dealerSignupDetails.phone,
                tags: ["Lever Auto Portal"]
            }

            axios({
                method: 'post',
                url: 'https://rest.gohighlevel.com/v1/contacts/',
                data: req,
                headers: { "Authorization": "Bearer 30bdca30-f2ab-4453-972b-ce03dcfc3c9d" }
            });

        }

    }

    const sendToSpotio = () => {

        if (process.env.REACT_APP_ENVIRONMENT === 'production') {

            //stageId: 12 //Cold Stage

            const req = {
                firstName: dealerSignupDetails.firstName,
                lastName: dealerSignupDetails.lastName,
                companyName: dealerSignupDetails.dealerName,
                email: dealerSignupDetails.email,
                tags: ["Website Lead New Application"],
                phone: dealerSignupDetails.phone,
                stageId: 4, //Warm Lead
                address: dealerSignupDetails.dealerAddressLine1 + ', ' +
                    (dealerSignupDetails.dealerAddressLine2 ? dealerSignupDetails.dealerAddressLine2 + ', ' : '') +
                    dealerSignupDetails.dealerCity + ', ' + dealerSignupDetails.dealerState + ' ' + dealerSignupDetails.dealerZipCode + ', USA',
                city: dealerSignupDetails.dealerCity,
                state: dealerSignupDetails.dealerState,
                zip: dealerSignupDetails.dealerZipCode,
                country: "USA",
                leadSourceInfo: leadSourceInfo,
                msclkid: msclkid,
                requestedFacilityAmount: dealerSignupDetails.requestedFacilityAmount,
                pipelineStatus: 'New',
            }

            const locationDetails = location.search.split('?');
            const queryParams = qs.parse(location.search.replace('?', ''));
            if (locationDetails && locationDetails.length > 1 && (queryParams && Object.keys(queryParams).length > 0 && Object.keys(queryParams).filter(item => !['msclkid', 'gclid', 'oauth_state_id'].includes(item)).length > 0))
                req.referral = locationDetails[1];

            if (currSection === 7) {
                req.tags = ["Website lead Application Submitted"];
                req.stageId = 7; //Application Submitted
                req.dealerPrincipals = principalInformationDetails.dealerPrincipal ? principalInformationDetails.dealerPrincipal.length : 0;
                req.dealerLocations = dealershipInfoS1Details.numberOfLocations;
                req.yearsInBusiness = dealershipInfoS1Details.yearsInBusiness;
            }

            return callAPI.post('/workflow/api/v1/shared/createUpdateLead', req)
                .then((response) => {
                    if (response.status === 200) {

                    }
                })

        }

    }

    let currentComponent = null;

    switch (currSection) {
        case 1:
            currentComponent = <ErrorBoundary><DealerSignUpInfo innerCurrSection={innerCurrSection} setInnerCurrSection={(section) => setInnerCurrSection(section)} formData={dealerSignupDetails} twoWayBind={(key, value, innerStep = null) => twoWayBind(key, value, innerStep)} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true) => submit(event, innerStep, isPreviousClick, forwardGlobalStep)} userNameCheck = {userNameCheck} userNameChecking = {(data) => userNameChecking(data)} /></ErrorBoundary>
            break;

        case 2:
            currentComponent = <ErrorBoundary><OnBoardingVerification phoneNumber={dealerSignupDetails.phone} requestedFacilityAmount={dealerSignupDetails.requestedFacilityAmount}
                sendOTP={event => sendOTP(event)} sendOTPEmail={event => sendOTPEmail(event)} verifyOTP={(event, otp) => verifyOTP(event, otp)} submit={(event) => submit(event)} /></ErrorBoundary>
            break;

        case 3:
            currentComponent = <ErrorBoundary><PrincipalInformation principalInformationDetails={principalInformationDetails} twoWayBind={(key, value, innerStep = null) => twoWayBind(key, value, innerStep)} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true) => submit(event, innerStep, isPreviousClick, forwardGlobalStep)} /></ErrorBoundary>
            break;

        case 4:
            currentComponent = <ErrorBoundary><FinancialDetails disableConnect={props.isLender ? true : false} dealerId={dealerId} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true) => submit(event, innerStep, isPreviousClick, forwardGlobalStep)} /></ErrorBoundary>
            break;

        case 5:
            currentComponent = <ErrorBoundary><DealershipInfo innerCurrSection={innerCurrSection} setInnerCurrSection={(section) => setInnerCurrSection(section)} dealershipInfoS1Details={dealershipInfoS1Details} dealershipInfoS2Details={dealershipInfoS2Details} dealershipInfoS3Details={dealershipInfoS3Details} twoWayBind={(key, value, innerStep = null) => twoWayBind(key, value, innerStep)} resetLeaseData={resetLeaseData} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true) => submit(event, innerStep, isPreviousClick, forwardGlobalStep)} /></ErrorBoundary>
            break;

        case 6:
            currentComponent = <ErrorBoundary><Attachments dealerId={dealerId} requestedFacilityAmount={dealerSignupDetails.requestedFacilityAmount} attachmentsDetails={attachmentsDetails} twoWayBind={(key, value, innerStep = null) => twoWayBind(key, value, innerStep)} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true) => submit(event, innerStep, isPreviousClick, forwardGlobalStep)} getData={getData} /></ErrorBoundary>
            break;

        case 7:
            currentComponent = <ErrorBoundary><NewDigitalSignature dealerId={dealerId} requestedFacilityAmount={dealerSignupDetails.requestedFacilityAmount} attachmentsDetails={attachmentsDetails} isFormSubmitted={isFormSubmitted} digitalSignatureDetails={digitalSignatureDetails} twoWayBind={(key, value, innerStep = null) => twoWayBind(key, value, innerStep)} submit={(event, innerStep = null, isPreviousClick = false, forwardGlobalStep = true, isSubmitted = false) => submit(event, innerStep, isPreviousClick, forwardGlobalStep, isSubmitted)} getData={getData} /></ErrorBoundary>
            break;

    }

    return (
        <React.Fragment>
            {
                toaster.showToaster ?
                    <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                    : null
            }
            <Loader show={showLoader} styleType='fixed' />
            <div className="forgotPassword-page-wrapper dealerSignUpOnboarding">
                <Container className="text-center py-5">
                    <div className="forgotPassword-form white-bg-text onBoarding-form">
                        <div className='onBoardingWrapper'>
                            <div className='onBoarding_tabs'>
                                <OnBoardingTabs currentComponentCount={currSection} changeTabForLender={(tab) => changeTabForLender(tab)} />
                                {currSection > 2 && localStorage.getItem('token') && !props.isLender ? (showCustomerSupport ? <a onClick={() => setShowCustomerSupport(false)} className='cursor-pointer onBoarding_link content-text-14px text-left white-text full-width display-block'><ArrowLeft className="mr-2" size={16} /> Back</a> : <a onClick={() => setShowCustomerSupport(true)} className='cursor-pointer onBoarding_link content-text-14px text-left white-text full-width display-block'><Headphones className="mr-2" size={16} /> Customer Support</a>) : null}
                                {currSection > 2 && localStorage.getItem('token') && !props.isLender ? <a onClick={() => { navigate('/DealerLogin'); dispatch(upDateMenu([])) }} className='cursor-pointer onBoarding_link content-text-14px text-left white-text full-width display-block'><LogOut className="mr-2" size={16} /> Sign Out</a> : null}
                            </div>
                            <div className='onBoarding_form_section'>
                                {
                                    showCustomerSupport ?
                                        <Customersupport menu={storeData.userMenu.length > 0 && storeData.userMenu.filter(item => item.name === 'Customer Support').length > 0 ? storeData.userMenu.filter(item => item.name === 'Customer Support')[0].innerItems : []} /> :
                                        currentComponent
                                }
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            <Modal className={` verify-otp-popup assign-funding-types-popup default-popup modal-backdrop-bg-color default-small-popup`} show={showOtpModal}
                onHide={() => setShowOtpModal(false)} backdrop={props.isStatic ? "static" : null} centered={props.centered} >
                <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                    <Modal.Title>
                        {props.icon ? props.icon : <span className='popup-title-icon'><Image src={confirmationIcon} /></span>}
                        <span className='flex-grow-1'>Verify OTP</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Loader show={showOTPLoader} styleType='absolute' />
                    <p className='mb-4'>Please enter the OTP send on your email ({dealerSignupDetails.email}) to continue.</p>
                    <Form noValidate
                        validated={otpValidated}
                        onSubmit={(event) => verifyOTPInPopup(event)}>
                        <div className='opt-inputs mb-4 justify-content-between'>
                            <Form.Control
                                required
                                ref={textD1}
                                type="text"
                                name="otp1"
                                minLength={1}
                                maxLength={1}
                                value={otpD1}
                                placeholder=""
                                onChange={event => setOtpDigits(1, event.target.value)}
                                onKeyDown={event => keyDownHandler(1, event.target.value, event.keyCode)}
                            />
                            <Form.Control
                                required
                                ref={textD2}
                                type="text"
                                name="otp2"
                                minLength={1}
                                maxLength={1}
                                value={otpD2}
                                placeholder=""
                                onChange={event => setOtpDigits(2, event.target.value)}
                                onKeyDown={event => keyDownHandler(2, event.target.value, event.keyCode)}
                            />
                            <Form.Control
                                required
                                ref={textD3}
                                type="text"
                                name="otp3"
                                minLength={1}
                                maxLength={1}
                                value={otpD3}
                                placeholder=""
                                onChange={event => setOtpDigits(3, event.target.value)}
                                onKeyDown={event => keyDownHandler(3, event.target.value, event.keyCode)}
                            />
                            <Form.Control
                                required
                                ref={textD4}
                                type="text"
                                name="otp4"
                                minLength={1}
                                maxLength={1}
                                value={otpD4}
                                placeholder=""
                                onChange={event => setOtpDigits(4, event.target.value)}
                                onKeyDown={event => keyDownHandler(4, event.target.value, event.keyCode)}
                            />
                            <Form.Control
                                required
                                ref={textD5}
                                type="text"
                                name="otp5"
                                minLength={1}
                                maxLength={1}
                                value={otpD5}
                                placeholder=""
                                onChange={event => setOtpDigits(5, event.target.value)}
                                onKeyDown={event => keyDownHandler(5, event.target.value, event.keyCode)}
                            />
                            <Form.Control
                                required
                                ref={textD6}
                                type="text"
                                name="otp6"
                                minLength={1}
                                maxLength={1}
                                value={otpD6}
                                className="mr-0"
                                placeholder=""
                                onChange={event => setOtpDigits(6, event.target.value)}
                                onKeyDown={event => keyDownHandler(6, event.target.value, event.keyCode)}
                            />
                        </div>
                        <p className='mb-3'>Didn’t Receive? <span className="blue-link-text cursor-pointer" onClick={event => sendOTPEmail(event)}>Resend OTP</span></p>
                        <Button variant='primary' className="default-btn" type="submit">Verify</Button>
                    </Form>
                </Modal.Body>
            </Modal>
            <ConfirmationPopup
                showModal={showLoginRedirectModal}
                onClose={() => setShowLoginRedirectModal(false)}
                modalTitle='Continue Onboarding Process'
                title={<p>Your onboarding process is already in progress, <br />please <Link to='/DealerLogin' className='blue-link-text'>click here</Link> to login and continue with your application.</p>}
                hideFooter={true}
            />
        </React.Fragment>
    )
}


export default NewOnBoarding;